import type { ProviderIcon } from '../../types/auth-providers/define';
import { resolveProviderIcon } from './resolve-provider-icon';

/**
 * Merge admin-stored branding (wire record) with the preset's defaults
 * (registry definition). Admin override wins; preset is fallback.
 */
export function resolveProviderVisuals(
	record: { icon?: string | null; iconColor?: string | null } | undefined,
	def: { icon?: string | ProviderIcon; iconColor?: string } | undefined,
	isDark: boolean,
): { iconName: string; iconColor: string | undefined } {
	return {
		iconName: resolveProviderIcon(record?.icon ?? def?.icon, isDark),
		iconColor: record?.iconColor ?? def?.iconColor,
	};
}
